import { render } from "./EmoJis.vue?vue&type=template&id=0165817e&scoped=true"
import script from "./EmoJis.vue?vue&type=script&lang=js"
export * from "./EmoJis.vue?vue&type=script&lang=js"

import "./EmoJis.vue?vue&type=style&index=0&id=0165817e&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0165817e"]])

export default __exports__